/* eslint-disable import/prefer-default-export */
/* istanbul ignore file */
import { RootState } from '../../stories/store';

export const selectSpinnerStatus = (state: RootState): boolean => (
    state.spinner.isLoading
);

export const selectSpinnerDescription = (state: RootState): string => (
    state.spinner.description
);
